/**
 * cart-gift-grid.js
 */

(function () {
  'use strict';

  const GIFT_HANDLES = [
    'stanley-1913-x-mexico-futbol-artist-sticker-pack',
    'stanley-1913-x-argentina-futbol-artist-sticker-pack',
    'stanley-1913-x-brazil-futbol-artist-sticker-pack'
  ];

  const ELIGIBLE_VARIANT_IDS = [
    '52505339429140','52505339461908','52505331138836',
    '52505363382548','52505366593812','52505366626580',
    '52505327337748'
  ];

  let _busy = false;
  let _removingGifts = false; // flag para evitar loop en el interceptor

  // ─── Leer estado del carrito ──────────────────────────────────────────────

  function getCartState() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var quota = 0;
        cart.items.forEach(function (item) {
          if (ELIGIBLE_VARIANT_IDS.indexOf(String(item.variant_id)) !== -1) {
            quota += item.quantity;
          }
        });

        var gifts = {};
        cart.items.forEach(function (item) {
          if (GIFT_HANDLES.indexOf(item.handle) !== -1) {
            gifts[item.handle] = {
              qty: item.quantity,
              variantId: String(item.variant_id),
              productId: String(item.product_id)
            };
          }
        });

        var giftsTotal = Object.values(gifts).reduce(function (sum, g) { return sum + g.qty; }, 0);

        return { quota: quota, gifts: gifts, giftsTotal: giftsTotal };
      });
  }

  // ─── Eliminar regalos si no hay elegibles ─────────────────────────────────

  function removeGiftsIfNoEligible() {
    if (_removingGifts) return Promise.resolve();
    return getCartState().then(function (state) {
      if (state.quota > 0) return; // hay elegibles, no hacer nada
      if (Object.keys(state.gifts).length === 0) return; // no hay regalos, nada que hacer

      // Guard contra loops infinitos: máximo 2 intentos por sesión de página.
      // Se resetea cuando la remoción es exitosa (gifts = 0).
      var attemptKey = '__cartGiftRemoveAttempts';
      var attempts = parseInt(sessionStorage.getItem(attemptKey) || '0', 10);
      if (attempts >= 2) {
        console.warn('[Gift Grid] Se alcanzó el máximo de intentos de remoción, cancelando.');
        return;
      }
      sessionStorage.setItem(attemptKey, String(attempts + 1));

      _removingGifts = true;

      // Un solo request atómico a /cart/update.js con todos los gifts.
      // Shopify rechaza cart mutations concurrentes con 409, por eso NO
      // usamos /cart/change.js en paralelo.
      var updates = {};
      Object.values(state.gifts).forEach(function (gift) {
        updates[gift.variantId] = 0;
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) {
          _removingGifts = false;
          if (!r.ok) {
            console.warn('[Gift Grid] /cart/update.js falló:', r.status);
            return;
          }
          // Éxito: reset del contador y refresco del carrito sin reload total.
          sessionStorage.removeItem(attemptKey);
          refreshCart();
        })
        .catch(function (err) {
          _removingGifts = false;
          console.error('[Gift Grid] Error al remover gifts:', err);
        });
    });
  }


  // ─── Detectar cambios en el carrito via clicks ───────────────────────────
  document.addEventListener('click', function (e) {
    if (_removingGifts) return;
    var btn = e.target.closest('.js-qty__adjust--minus, .cart__remove a');
    if (!btn) return;
    setTimeout(removeGiftsIfNoEligible, 600);
    setTimeout(removeGiftsIfNoEligible, 1200);
  });

  // ─── Init grid ────────────────────────────────────────────────────────────

  function initGiftGrid() {
    const grid = document.getElementById('cart-gift-grid');
    if (!grid) return;

    getCartState().then(function (state) {
      syncUI(state);
      attachEvents(grid);
    });
  }

  function attachEvents(grid) {
    grid.querySelectorAll('.gift-counter-btn').forEach(function (btn) {
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });

    grid.querySelectorAll('.gift-counter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (_busy) return;
        const action = btn.dataset.action;
        const variantId = btn.dataset.variantId;
        const productId = btn.dataset.productId;
        handleCounter(action, variantId, productId, btn);
      });
    });
  }

  // ─── Contador ─────────────────────────────────────────────────────────────

  function handleCounter(action, variantId, productId, btn) {
    _busy = true;
    const card = btn.closest('.cart-gift-card');
    card.classList.add('cart-gift-card--loading');

    getCartState().then(function (state) {
      const handle = card.dataset.giftHandle;
      const currentGift = state.gifts[handle];
      const currentQty = currentGift ? currentGift.qty : 0;

      if (action === 'plus') {
        if (state.giftsTotal >= state.quota) {
          _busy = false;
          card.classList.remove('cart-gift-card--loading');
          return Promise.resolve();
        }
        return changeGiftQty(variantId, currentQty + 1);
      } else if (action === 'minus') {
        if (currentQty <= 0) {
          _busy = false;
          card.classList.remove('cart-gift-card--loading');
          return Promise.resolve();
        }
        return changeGiftQty(variantId, currentQty - 1);
      }
    })
    .then(function () { return getCartState(); })
    .then(function (state) {
      syncUI(state);
      refreshCart();
      _busy = false;
    })
    .catch(function (err) {
      console.error('[Gift Grid]', err);
      card.classList.remove('cart-gift-card--loading');
      _busy = false;
    });
  }

  function changeGiftQty(variantId, newQty) {
    if (newQty === 0) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      }).then(function (r) { return r.json(); });
    } else {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var exists = cart.items.some(function (i) { return String(i.variant_id) === String(variantId); });
          if (exists) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: variantId, quantity: newQty })
            }).then(function (r) { return r.json(); });
          } else {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: [{ id: parseInt(variantId), quantity: 1, properties: { _gift: 'true', _free: 'true' } }]
              })
            }).then(function (r) { return r.json(); });
          }
        });
    }
  }

  // ─── Sync UI ──────────────────────────────────────────────────────────────

  function syncUI(state) {
    const grid = document.getElementById('cart-gift-grid');
    if (!grid) return;

    const quotaDisplay = document.getElementById('gift-quota-display');
    if (quotaDisplay) quotaDisplay.textContent = state.quota;

    const available = state.quota - state.giftsTotal;

    grid.querySelectorAll('.cart-gift-card').forEach(function (card) {
      const handle = card.dataset.giftHandle;
      const giftData = state.gifts[handle];
      const qty = giftData ? giftData.qty : 0;

      card.classList.remove('cart-gift-card--loading');
      card.classList.toggle('cart-gift-card--has-qty', qty > 0);

      const qtyEl = card.querySelector('.gift-counter-qty');
      if (qtyEl) qtyEl.textContent = qty;

      const minusBtn = card.querySelector('.gift-counter-minus');
      if (minusBtn) minusBtn.disabled = (qty === 0);

      const plusBtn = card.querySelector('.gift-counter-plus');
      if (plusBtn) plusBtn.disabled = (available <= 0);
    });
  }

  // ─── Refresh carrito ──────────────────────────────────────────────────────

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (window.theme && window.theme.cart && typeof window.theme.cart.load === 'function') {
      window.theme.cart.load();
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-count, .cart__count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // ─── Bloquear controles en items de regalo ────────────────────────────────

  function lockGiftItemControls() {
    document.querySelectorAll('.cart__item').forEach(function (item) {
      var nameEl = item.querySelector('.cart__item-name');
      if (!nameEl) return;
      var href = nameEl.getAttribute('href') || '';
      var isGift = GIFT_HANDLES.some(function (h) { return href.indexOf(h) !== -1; });
      if (!isGift) return;

      var input = item.querySelector('.js-qty__num');
      if (input) { input.disabled = true; input.readOnly = true; }

      item.querySelectorAll('.js-qty__adjust').forEach(function (btn) {
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.25';
      });

      var remove = item.querySelector('.cart__remove');
      if (remove) remove.style.display = 'none';
    });
  }

  // ─── Inicialización ───────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initGiftGrid();
      lockGiftItemControls();
      removeGiftsIfNoEligible();
    });
  } else {
    initGiftGrid();
    lockGiftItemControls();
    removeGiftsIfNoEligible();
  }

  document.addEventListener('cart:rendered', function () {
    initGiftGrid();
    lockGiftItemControls();
    removeGiftsIfNoEligible();
  });

  document.addEventListener('cart:loaded', function () {
    initGiftGrid();
    lockGiftItemControls();
    removeGiftsIfNoEligible();
  });

  // MutationObserver: re-inicializar cuando el DOM cambia
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        lockGiftItemControls();
        if (node.id === 'cart-gift-grid' || (node.querySelector && node.querySelector('#cart-gift-grid'))) {
          initGiftGrid();
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();